import React from 'react';
import ReduxToastr from 'react-redux-toastr'
import Header from '../components/layout/HeaderComponent';
import '../styles/app.less';
import AccountEdit from '../components/admin/AccountEdit.js';
import SkiresortEdit from '../components/admin/SkiresortEdit';
import SkiresortAdd from '../components/admin/SkiresortAdd';
import GroomersEdit from '../components/admin/GroomersEdit';
import SkiresortSwitch from '../components/admin/SkiresortSwitch';
import QuickSend from '../components/admin/Quicksend';
import UsersEdit from '../components/admin/UsersEdit';
import LoginScreen from '../components/Login';
import {connect} from 'react-redux';
import OpeningDatesEdit from 'components/admin/OpeningClosingDateEdit';

const BLUE_PANES = {
  MY_ACCOUNT: 'myaccount',
  EDIT_SKIRESORT: 'editskiresort',
  EDIT_DATES: 'editdates',
  EDIT_GROOMERS: 'editgroomers',
  SWITCH: 'switchskiresort',
  ADD_SKIRESORT: 'addskiresort',
  EDIT_ACCOUNTS: 'editaccounts',
  QUICKSEND: 'quicksend'
};


/** L'application au complet, avec anonyme/enregistré et affichage des panneaux */
@connect(
  state => ({user: state.user}),
  {}
)
class App extends React.Component {


  constructor() {
    super();
    this.state = {
      bluePane: null
    };
  }

  getCorrespondingBluePane() {
    const {bluePane} = this.state;
    let bluePaneComponent = null;
    switch (bluePane) {
      case BLUE_PANES.MY_ACCOUNT:
        bluePaneComponent = <AccountEdit onEnd={() => this.setState({bluePane: null})}/>;
        break;
      case BLUE_PANES.EDIT_SKIRESORT:
        bluePaneComponent = <SkiresortEdit/>;
        break;
      case BLUE_PANES.EDIT_DATES:
        bluePaneComponent = <OpeningDatesEdit onEnd={() => this.setState({bluePane: null})}/>;
        break;
      case BLUE_PANES.EDIT_GROOMERS:
        bluePaneComponent = <GroomersEdit/>;
        break;
      case BLUE_PANES.SWITCH:
        bluePaneComponent = <SkiresortSwitch onEnd={() => this.setState({bluePane: null})}/>;
        break;
      case BLUE_PANES.ADD_SKIRESORT:
        bluePaneComponent = <SkiresortAdd onEnd={() => this.setState({bluePane: null})}/>;
        break;
      case BLUE_PANES.EDIT_ACCOUNTS:
        bluePaneComponent = <UsersEdit onEnd={() => this.setState({bluePane: null})}/>;
        break;
      case BLUE_PANES.QUICKSEND:
        bluePaneComponent = <QuickSend onEnd={() => this.setState({bluePane: null})}/>;
    }
    return bluePaneComponent === null ? null : <div>
      <div className="overlay" onClick={() => this.setState({bluePane: null})}/>
      {bluePaneComponent}</div>;
  }

  renderLoggedIn() {
    let onPaneSelected = paneName => this.setState({bluePane: this.state.bluePane !== paneName ? paneName : null});
    return (
      <div id="App" style={{fontFamily: 'arial'}}>
        <Header
          onPaneSelected={onPaneSelected} paneName={this.state.bluePane}/>
        { this.getCorrespondingBluePane() }
        <div className="app">
          {this.props.children}
        </div>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          position="bottom-right"/>
      </div>
    );
  }

  renderAnonymous() {
    let onPaneSelected = paneName => this.setState({bluePane: this.state.bluePane !== paneName ? paneName : null});
    return (
      <div id="App" style={{fontFamily: 'arial'}}>
        { this.getCorrespondingBluePane() }
        <LoginScreen onPaneSelected={onPaneSelected}/>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          position="bottom-right"/>
      </div>
    );
  }

  render() {
    if (this.props.user.selectedSkiresort !== null) {
      return this.renderLoggedIn();
    } else {
      return this.renderAnonymous();
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js